export const LanguageLevels = [
  { label: 'Beginner', value: 'BEGINNER' },
  { label: 'Lower Intermediate', value: 'LOWER_INTERMEDIATE' },
  { label: 'Intermediate', value: 'INTERMEDIATE' },
  { label: 'Upper Intermediate', value: 'UPPER_INTERMEDIATE' },
  { label: 'Advanced', value: 'ADVANCED' },
] as const;
